export enum KeypadDecimalEntryMode {
  FIXED_SHIFT = "FIXED_SHIFT",
  EXPLICIT = "EXPLICIT",
}
